<div class="container-fluid g-0 m-0">
  <!-- Back Navigation -->
  <div class="row g-0 m-0 d-flex pt-5 pb-5 align-items-center">
    <div class="col-md-1 d-flex pe-4 justify-content-end">
      <div class="button-back pb-1" [routerLink]="['/devices/all-devices']">
        <svg-icon alt="Back" src="assets/core/back-button.svg"></svg-icon>
      </div>
    </div>
    <div class="col-md-11">
      <h2 class="col pb-2 m-0 title">{{ "DEVICESETUP_TITLE" | translate }}</h2>
      <h6 class="col subtitle">{{ "DEVICESETUP_SUBTITLE" | translate }}</h6>
    </div>
  </div>



  <!-- Complete Screen -->
  @if (submitted) {
  <div class="d-flex flex-column justify-content-center align-items-center text-center p-5 pt-0 ">
    <div class="mb-3">
      <svg-icon src="assets/device/device-setup-success.svg" alt="Success"></svg-icon>
    </div>
    <div class="mb-2 popup-title">
      <span class="h5">{{ "DEVICESETUPCOMPLETE" | translate }}</span>
    </div>
    <div class="mb-4 item-info fw-normal">
      <span>{{ "DEVICESETUPSUCCESS" | translate }}</span>
    </div>
    <div class="d-flex gap-3">
      <button class="button-cancel" type="button" (click)="resetDeviceForm()">
        {{ "ADDNEWDEVICE" | translate }}
      </button>
      <button class="button-submit" type="button" [routerLink]="['/devices/all-devices']">
        {{ "CLICKTOCONTINUE" | translate }}
      </button>
    </div>
  </div>
  }

  <!-- Form -->
  @if (!submitted) {
  <div class="row g-0 m-0 d-flex">
    <form [formGroup]="deviceForm" (ngSubmit)="onSubmit()" class="pt-0">
      <div class="p-5 pt-0 pb-4 d-flex flex-column">

        <!-- ===== SECTION: BASIC INFORMATION ===== -->
        <div class="form-section">
          <div class="section-header">
            <h5 class="section-name">{{ "DEVICESETUPTABS_BASICINFO" | translate }}</h5>
          </div>
          <div formGroupName="basicInfo" class="row g-0 m-0 d-flex justify-content-center">
            <!-- Service Name -->
            <div class="form-item">
              <label class="form-label" for="serviceName">{{ "DEVICESETUP_SERVICENAME" | translate }}*</label>
              <div class="form-input">
                <input id="serviceName" formControlName="serviceName" type="text" />
                <div *ngIf="formErrorsExists('basicInfo.serviceName')" class="validation-error">
                  {{ "DEVICESETUP_SERVICENAME" | translate }} {{ "DEVICESETUP_ISREQUIRED" | translate }}.
                </div>
                <div
                  *ngIf="deviceForm.get('basicInfo.serviceName')?.untouched && deviceForm.get('basicInfo.serviceName')?.invalid"
                  class="validation-instruction">
                  {{ "DEVICESETUP_SERVICENAMEDESC" | translate }}
                </div>
              </div>
            </div>
            <!-- Service Number -->
            <div class="form-item">
              <label class="form-label" for="serviceNumber">{{ "DEVICESETUP_SERVICENUMBER" | translate }}</label>
              <div class="form-input">
                <input id="serviceNumber" formControlName="serviceNumber" type="text" />
                <div *ngIf="!deviceForm.get('basicInfo.serviceNumber')?.value" class="validation-instruction">
                  {{ "DEVICESETUP_SERVICENUMBERDESC" | translate }}
                </div>
              </div>
            </div>
            <!-- Asset Type -->
            <div class="form-item">
              <label class="form-label" for="assetType">{{ "DEVICESETUP_ASSETTYPE" | translate }}*</label>
              <div class="form-input">
                <select id="assetType" formControlName="assetType" (change)="onAssetTypeSelected($event)">
                  <option *ngFor="let item of assetTypes" [value]="item.value">{{ item.name }}</option>
                </select>
                <div *ngIf="formErrorsExists('basicInfo.assetType')" class="validation-error">
                  {{ "DEVICESETUP_ASSETTYPE" | translate }} {{ "DEVICESETUP_ISREQUIRED" | translate }}.
                </div>
                <div
                  *ngIf="deviceForm.get('basicInfo.assetType')?.untouched && deviceForm.get('basicInfo.assetType')?.invalid"
                  class="validation-instruction">
                  {{ "DEVICESETUP_ASSETTYPEDESC" | translate }}
                </div>
              </div>
            </div>
            <!-- Parent -->
            <div class="form-item">
              <label class="form-label" for="address">{{ "DEVICESETUP_PARENT" | translate }}</label>
              <div class="form-input ">
                <app-parent-meter-dropdown-search [disabled]="!selectedAssetType" [fetchItems]="fetchParents"
                  [selected]="selectedParent" [placeholder]="'SEARCHBY_METERNUMBER_OR_ASSETNAME'"
                  (selectedItem)="onParentSelected($event)" />
                <div *ngIf="formErrorsExists('basicInfo.parent')" class="validation-error">
                  {{ "DEVICESETUP_PARENT" | translate }} {{ "DEVICESETUP_ISREQUIRED" | translate }}.
                </div>
                <div
                  *ngIf="deviceForm.get('basicInfo.parent')?.untouched && deviceForm.get('basicInfo.parent')?.invalid"
                  class="validation-instruction">
                  {{ "DEVICESETUP_PARENTERROR" | translate }}
                </div>
              </div>
            </div>
            <!-- Address -->
            <div class="form-item">
              <label class="form-label" for="address">{{ "DEVICESETUP_DEVICEADDRESS" | translate }}*</label>
              <div class="form-input">
                <input id="address" formControlName="address" type="text" />
                <div *ngIf="formErrorsExists('basicInfo.address')" class="validation-error">
                  {{ "DEVICESETUP_DEVICEADDRESS" | translate }} {{ "DEVICESETUP_ISREQUIRED" | translate }}.
                </div>
                <div
                  *ngIf="deviceForm.get('basicInfo.address')?.untouched && deviceForm.get('basicInfo.address')?.invalid"
                  class="validation-instruction">
                  {{ "DEVICESETUP_DEVICEADDRESSDESC" | translate }}
                </div>
              </div>
            </div>
            <!-- Region -->
            <div class="form-item">
              <label class="form-label" for="region">{{ "DEVICESETUP_REGION" | translate }}*</label>
              <div class="form-input">
                <select id="region" formControlName="region" (change)="getAreasByRegion($event)">
                  <option value="" disabled hidden></option>
                  <option *ngFor="let item of regions" [value]="item.value">{{ item.name }}</option>
                </select>
                <div *ngIf="formErrorsExists('basicInfo.region')" class="validation-error">
                  {{ "DEVICESETUP_REGION" | translate }} {{ "DEVICESETUP_ISREQUIRED" | translate }}.
                </div>
                <div
                  *ngIf="deviceForm.get('basicInfo.region')?.untouched && deviceForm.get('basicInfo.region')?.invalid"
                  class="validation-instruction">
                  {{ "DEVICESETUP_REGIONDESC" | translate }}
                </div>
              </div>
            </div>
            <!-- Area -->
            <div class="form-item">
              <label class="form-label" for="area">{{ "DEVICESETUP_AREA" | translate }}*</label>
              <div class="form-input">
                <select id="area" formControlName="area">
                  <option value="" disabled hidden></option>
                  <option *ngFor="let item of areas" [value]="item.value">{{ item.name }}</option>
                </select>
                <div *ngIf="formErrorsExists('basicInfo.area')" class="validation-error">
                  {{ "DEVICESETUP_AREA" | translate }} {{ "DEVICESETUP_ISREQUIRED" | translate }}.
                </div>
                <div *ngIf="deviceForm.get('basicInfo.area')?.untouched && deviceForm.get('basicInfo.area')?.invalid"
                  class="validation-instruction">
                  {{ "DEVICESETUP_AREADESC" | translate }}
                </div>
              </div>
            </div>
            <!-- Service Type -->
            <div class="form-item">
              <label class="form-label" for="serviceType">{{ "DEVICESETUP_SERVICETYPE" | translate }}</label>
              <div class="form-input">
                <select id="serviceType" formControlName="serviceType">
                  <option *ngFor="let item of serviceTypes" [value]="item.value">{{ item.name }}</option>
                </select>
                <div *ngIf="!deviceForm.get('basicInfo.serviceType')?.value" class="validation-instruction">
                  {{ "DEVICESETUP_SERVICETYPEDESC" | translate }}.
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- ===== SECTION: METER INFORMATION ===== -->
        <div class="form-section">
          <div class="section-header">
            <h5 class="section-name">{{ "DEVICESETUPTABS_METERINFO" | translate }}</h5>
          </div>
          <div formGroupName="meterInfo" class="row g-0 m-0 d-flex justify-content-center">
            <!-- Meter Number -->
            <div class="form-item">
              <label class="form-label" for="meterNumber">{{ "DEVICESETUP_METERNO" | translate }}*</label>
              <div class="form-input">
                <input id="meterNumber" formControlName="meterNumber" type="text" />
                <div *ngIf="formErrorsExists('meterInfo.meterNumber')" class="validation-error">
                  {{ "DEVICESETUP_METERNO" | translate }}{{ "DEVICESETUP_ISREQUIRED" | translate }}
                </div>
                <div *ngIf="!deviceForm.get('meterInfo.meterNumber')?.value" class="validation-instruction">
                  {{ "DEVICESETUP_METERNODESC" | translate }}
                </div>
                <div *ngIf="deviceForm.get('meterInfo.meterNumber')?.errors?.['pattern']" class="validation-error">
                  {{ "METERNUMBER_ERROR" | translate }}
                </div>
              </div>
            </div>
            <!-- Meter Make -->
            <div class="form-item">
              <label class="form-label" for="meterMake">{{ "DEVICESETUP_METERMAKE" | translate }}*</label>
              <div class="form-input">
                <select id="meterMake" formControlName="meterMake" (change)="getMeterModels()">
                  <option *ngFor="let item of meterMakers" [value]="item.value">{{ item.name }}</option>
                </select>
                <div *ngIf="formErrorsExists('meterInfo.meterMake')" class="validation-error">
                  {{ "DEVICESETUP_METERMAKE" | translate }} {{ "DEVICESETUP_ISREQUIRED" | translate }}.
                </div>
                <div
                  *ngIf="deviceForm.get('meterInfo.meterMake')?.untouched && deviceForm.get('meterInfo.meterMake')?.invalid"
                  class="validation-instruction">
                  {{ "DEVICESETUP_METERMAKEDESC" | translate }}
                </div>
              </div>
            </div>
            @if (deviceForm.get('meterInfo.meterMake')?.value) {
            <!-- Meter Model -->
            <div class="form-item">
              <label class="form-label" for="meterModel">{{ "DEVICESETUP_METERMODEL" | translate }}*</label>
              <div class="form-input">
                <select id="meterModel" formControlName="meterModel"
                  (change)="getMeterModel(deviceForm.get('meterInfo.meterModel')?.value)">
                  <option value="" disabled selected hidden></option>
                  <option *ngFor="let item of meterModels" [value]="item.value">{{ item.name }}</option>
                </select>
                <div *ngIf="formErrorsExists('meterInfo.meterModel')" class="validation-error">
                  {{ "DEVICESETUP_METERMODEL" | translate }} {{ "DEVICESETUP_ISREQUIRED" | translate }}.
                </div>
                <div
                  *ngIf="deviceForm.get('meterInfo.meterModel')?.untouched && deviceForm.get('meterInfo.meterModel')?.invalid"
                  class="validation-instruction">
                  {{ "DEVICESETUP_METERMODELDESC" | translate }}
                </div>
              </div>
            </div>
            }
            @if (deviceForm.get('meterInfo.meterModel')?.value) {
            <!-- Meter Phase -->
            <div class="form-item">
              <label class="form-label" for="meterPhase">{{ "DEVICESETUP_METERPHASE" | translate }}:</label>
              <div class="form-input">
                <input id="meterPhase" formControlName="meterPhase" type="text" />
                <div class="validation-instruction">{{ "DEVICESETUP_METERPHASEDESC" | translate }}</div>
              </div>
            </div>
            }

            <!-- Meter Type -->
            <div class="form-item">
              <label class="form-label" for="meterType">{{ "DEVICESETUP_METERTYPE" | translate }}*</label>
              <div class="custom-div">
                <div class="radio-div custom-radio-div">
                  <div class="element" *ngFor="let item of meterTypeDictionary">
                    <span class="radiobox"
                      [ngClass]="{ selected: deviceForm.get('meterInfo.meterType')?.value === item }"
                      (click)="selectRadioOption('meterType', item)">
                      {{ item }}
                      <input id="{{item}}" type="radio" name="meterType" [value]="item" formControlName="meterType" />
                      <label for="{{ item }}"></label>
                    </span>
                  </div>
                </div>
                <div *ngIf="formErrorsExists('meterInfo.meterType')" class="validation-error">
                  {{ "DEVICESETUP_METERTYPEDESC" | translate }}
                </div>
              </div>
            </div>
            <!-- Meter Timezone -->
            <div class="form-item">
              <label class="form-label" for="meterTimeZone">{{ "DEVICESETUP_TIMEZONE" | translate }}*</label>
              <div class="form-input">
                <select id="meterTimeZone" formControlName="meterTimeZone">
                  <option *ngFor="let zone of timezones" [value]="zone.value">{{ zone.name }}</option>
                </select>
                <div *ngIf="formErrorsExists('meterInfo.meterTimeZone')" class="validation-error">
                  {{ "DEVICESETUP_TIMEZONE" | translate }} {{ "DEVICESETUP_ISREQUIRED" | translate }}.
                </div>
                <div
                  *ngIf="deviceForm.get('meterInfo.meterTimeZone')?.untouched && deviceForm.get('meterInfo.meterTimeZone')?.invalid"
                  class="validation-instruction">
                  {{ "DEVICESETUP_TIMEZONEDESC" | translate }}
                </div>
              </div>
            </div>
            <!-- Meter Manufacture Date -->
            <div class="form-item">
              <label class="form-label" for="meterManufactureDate">{{ "DEVICESETUP_MANUFACTUREDATE" | translate }}</label>
              <div class="form-input">
                <div class="date-container" (click)="toggleManufactureDatepicker(); $event.stopPropagation()">
                  <span class="ps-2 pe-2">{{ "DATE" | translate }}</span>
                  <div class="date-input">
                    <input id="meterManufactureDate" [value]="selectedManufactureDate" formControlName="meterManufactureDate"
                      type="text" readonly />
                    <img alt="Calendar" src="assets/device/calendar.svg" />
                  </div>
                </div>
                <ng-container *ngIf="isManufactureDatepickerShown">
                  <app-datepicker #md [scale]="1.1" [range]="false"
                    [inputFromDate]="deviceForm.get('meterInfo.meterManufactureDate')?.value"
                    (dateRangeChanged)="onManufactureDateChanged($event)"
                    (close)="isManufactureDatepickerShown = false"></app-datepicker>
                </ng-container>
                <div *ngIf="!deviceForm.get('meterInfo.meterManufactureDate')?.value" class="validation-instruction">
                  {{ "DEVICESETUP_MANUFACTUREDATEDESC" | translate }}
                </div>
                <div class="clear d-flex justify-content-end" *ngIf="selectedManufactureDate" (click)="clearManufactureDate()">
                  <span>{{ "CLEAR" | translate }}</span>
                </div>
              </div>
            </div>
            <div class="section-title-segment pb-4">
              <h5 class="section-title">{{ "CT_RATIO_TITLE" | translate }}</h5>
              <h6 class="section-subtitle">{{ "CT_RATIO_SUBTITLE" | translate }}</h6>
            </div>
            <!-- Current Numerator -->
            <div class="form-item">
              <label class="form-label" for="ctNumerator">{{ "DEVICESETUP_CT_NUMERATOR" | translate }}:</label>
              <div class="form-input">
                <div class="form-input-div">
                  <input id="ctNumerator" formControlName="currentTransformerRatioNumerator" type="number" step="1" />
                </div>
                @if (formErrorsExists('meterInfo.currentTransformerRatioNumerator')) {
                <div class="validation-error">
                  @if(this.deviceForm.get('meterInfo.currentTransformerRatioNumerator')?.errors?.['required']) {
                  {{ "DEVICESETUP_CT_NUMERATOR_REQUIRED_ERROR" | translate }}
                  }
                  @if(this.deviceForm.get('meterInfo.currentTransformerRatioNumerator')?.errors?.['min']) {
                  {{ "DEVICESETUP_CT_NUMERATOR_ERROR" | translate }}
                  }
                </div>
                } @else {
                <div *ngIf="!deviceForm.get('meterInfo.currentTransformerRatioNumerator')?.value"
                  class="validation-instruction">
                  {{ "DEVICESETUP_CT_NUMERATORDESC" | translate }}
                </div>
                }
              </div>
            </div>
            <!-- Current Denominator -->
            <div class="form-item">
              <label class="form-label" for="ctDenominator">{{ "DEVICESETUP_CT_DENOMINATOR" | translate }}:</label>
              <div class="form-input">
                <div class="form-input-div">
                  <input id="ctDenominator" formControlName="currentTransformerRatioDenominator" type="number"
                    step="1" />
                </div>
                @if (formErrorsExists('meterInfo.currentTransformerRatioDenominator')) {
                <div class="validation-error">
                  @if(this.deviceForm.get('meterInfo.currentTransformerRatioDenominator')?.errors?.['required']) {
                  {{ "DEVICESETUP_CT_DENOMINATOR_REQUIRED_ERROR" | translate }}
                  }
                  @if(this.deviceForm.get('meterInfo.currentTransformerRatioDenominator')?.errors?.['min']) {
                  {{ "DEVICESETUP_CT_DENOMINATOR_ERROR" | translate }}
                  }
                </div>
                } @else {
                <div *ngIf="!deviceForm.get('meterInfo.currentTransformerRatioDenominator')?.value"
                  class="validation-instruction">
                  {{ "DEVICESETUP_CT_DENOMINATORDESC" | translate }}
                </div>
                }
              </div>
            </div>
            <div class="section-title-segment pb-4">
              <h5 class="section-title">{{ "VT_RATIO_TITLE" | translate }}</h5>
              <h6 class="section-subtitle">{{ "VT_RATIO_SUBTITLE" | translate }}</h6>
            </div>
            <!-- Voltage Numerator -->
            <div class="form-item">
              <label class="form-label" for="vtNumerator">{{ "DEVICESETUP_VT_NUMERATOR" | translate }}:</label>
              <div class="form-input">
                <div class="form-input-div">
                  <input id="vtNumerator" formControlName="voltageTransformerRatioNumerator" type="number" step="1" />
                </div>
                @if (formErrorsExists('meterInfo.voltageTransformerRatioNumerator')) {
                <div class="validation-error">
                  @if(this.deviceForm.get('meterInfo.voltageTransformerRatioNumerator')?.errors?.['required']) {
                  {{ "DEVICESETUP_VT_NUMERATOR_REQUIRED_ERROR" | translate }}
                  }
                  @if(this.deviceForm.get('meterInfo.voltageTransformerRatioNumerator')?.errors?.['min']) {
                  {{ "DEVICESETUP_VT_NUMERATOR_ERROR" | translate }}
                  }
                </div>
                } @else {
                <div *ngIf="!deviceForm.get('meterInfo.voltageTransformerRatioNumerator')?.value"
                  class="validation-instruction">
                  {{ "DEVICESETUP_VT_NUMERATORDESC" | translate }}
                </div>
                }
              </div>
            </div>
            <!-- Voltage Denominator -->
            <div class="form-item">
              <label class="form-label" for="vtDenominator">{{ "DEVICESETUP_VT_DENOMINATOR" | translate }}:</label>
              <div class="form-input">
                <div class="form-input-div">
                  <input id="vtDenominator" formControlName="voltageTransformerRatioDenominator" type="number"
                    step="1" />
                </div>
                @if (formErrorsExists('meterInfo.voltageTransformerRatioDenominator')) {
                <div class="validation-error">
                  @if(this.deviceForm.get('meterInfo.voltageTransformerRatioDenominator')?.errors?.['required']) {
                  {{ "DEVICESETUP_VT_DENOMINATOR_REQUIRED_ERROR" | translate }}
                  }
                  @if(this.deviceForm.get('meterInfo.voltageTransformerRatioDenominator')?.errors?.['min']) {
                  {{ "DEVICESETUP_VT_DENOMINATOR_ERROR" | translate }}
                  }
                </div>
                } @else {
                <div *ngIf="!deviceForm.get('meterInfo.voltageTransformerRatioDenominator')?.value"
                  class="validation-instruction">
                  {{ "DEVICESETUP_VT_DENOMINATORDESC" | translate }}
                </div>
                }
              </div>
            </div>
          </div>
        </div>

        <!-- ===== SECTION: CONNECTIVITY ===== -->
        <div class="form-section">
          <div class="section-header">
            <h5 class="section-name">{{ "DEVICESETUPTABS_CONNECTIVITY" | translate }}</h5>
          </div>
          <div formGroupName="connectivity" class="row g-0 m-0 d-flex justify-content-center">
            <!-- GSM Provider -->
            <div class="form-item">
              <label class="form-label" for="gsmProvider">{{ "DEVICESETUP_GSMPROVIDER" | translate }}*</label>
              <div class="form-input">
                <div class="form-input-div">
                  <select id="gsmProvider" formControlName="gsmProvider" (change)="getIpFromGsmProvider()">
                    <option *ngFor="let item of gsmProviderDictionary" [value]="item">{{ item }}</option>
                  </select>
                </div>
                <div *ngIf="formErrorsExists('connectivity.gsmProvider')" class="validation-error">
                  {{ "DEVICESETUP_GSMPROVIDER" | translate }} {{ "DEVICESETUP_ISREQUIRED" | translate }}.
                </div>
                <div
                  *ngIf="deviceForm.get('connectivity.gsmProvider')?.untouched && deviceForm.get('connectivity.gsmProvider')?.invalid"
                  class="validation-instruction">
                  {{ "DEVICESETUP_GSMPROVIDERDESC" | translate }}
                </div>
              </div>
            </div>
            <!-- Cellular Sim Serial Number -->
            <div class="form-item">
              <label class="form-label" for="cellularSimSerialNumber">{{ "DEVICESETUP_CELLULARSIMSN" | translate
                }}*</label>
              <div class="form-input">
                <input id="cellularSimSerialNumber" formControlName="cellularSimSerialNumber"
                  [attr.disabled]="!deviceForm.get('connectivity.gsmProvider')?.value ? '' : null" type="text"
                  (change)="getIpFromGsmProvider()" />
                <div class="validation-error">{{ cellularSimSerialNumberError }}</div>
                <div *ngIf="formErrorsExists('connectivity.cellularSimSerialNumber')" class="validation-error">
                  {{ "DEVICESETUP_CELLULARSIMSN" | translate }} {{ "DEVICESETUP_ISREQUIRED" | translate }}.
                </div>
                <div *ngIf="deviceForm.get('connectivity.gsmProvider')?.invalid" class="validation-error">
                  {{ "DEVICESETUP_GSMFIRST" | translate }}
                </div>
                <div
                  *ngIf="deviceForm.get('connectivity.cellularSimSerialNumber')?.untouched && deviceForm.get('connectivity.cellularSimSerialNumber')?.invalid"
                  class="validation-instruction">
                  {{ "DEVICESETUP_CELLULARSIMSNDESC" | translate }}
                </div>
              </div>
            </div>
            <!-- Meter IP -->
            <div class="form-item">
              <label class="form-label" for="meterIp">{{ "DEVICESETUP_METERIP" | translate }}*</label>
              <div class="form-input">
                <input id="meterIp" formControlName="meterIp" type="text" />
                <div *ngIf="formErrorsExists('connectivity.meterIp')" class="validation-error">
                  {{ "DEVICES_INVALID" | translate }} {{ "DEVICESETUP_METERIP" | translate }} {{
                  "DEVICESETUP_DEVICEADDRESS" | translate }}
                </div>
                <div *ngIf="deviceForm.get('connectivity.meterIp')?.untouched" class="validation-instruction">
                  {{ "DEVICESETUP_METERIPDESC" | translate }}
                </div>
              </div>
            </div>
            <!-- Meter Port -->
            <div class="form-item">
              <label class="form-label" for="meterPort">{{ "DEVICESETUP_METERPORT" | translate }}*</label>
              <div class="form-input">
                <div class="form-input-div">
                  <input id="meterPort" formControlName="meterPort" type="number" />
                </div>
                @if (formErrorsExists('connectivity.meterPort')) {
                <div class="validation-error">{{ "INTEGER_ERROR" | translate }}</div>
                } @else {
                <div *ngIf="!deviceForm.get('connectivity.meterPort')?.value" class="validation-instruction">
                  {{ "DEVICESETUP_METERPORTDESC" | translate }}
                </div>
                }
              </div>
            </div>
            <!-- Meter Interface -->
            <div class="form-item">
              <label class="form-label" for="meterInterface">{{ "DEVICESETUP_INTERFACE" | translate }}*</label>
              <div class="form-input">
                <input id="meterInterface" formControlName="meterInterface" type="text" />
                <div class="validation-instruction">{{ "DEVICESETUP_INTERFACEINFODESC" | translate }}</div>
              </div>
            </div>
            <!-- Data Collection Interval -->
            <div class="form-item">
              <label class="form-label" for="dataCollectionInterval">{{ "DEVICESETUP_DATACOLLECTIONINTERVALS" |
                translate }}*</label>
              <div class="form-input">
                <select id="dataCollectionInterval" formControlName="dataCollectionInterval">
                  <option *ngFor="let interval of intervals" [value]="interval.value">{{ formatInterval(interval.value)
                    }}</option>
                </select>
                <div *ngIf="!deviceForm.get('connectivity.dataCollectionInterval')?.value"
                  class="validation-instruction">
                  {{ "DEVICESETUP_DATACOLLECTIONINTERVALSDESC" | translate }}
                </div>
                <div *ngIf="formErrorsExists('connectivity.dataCollectionInterval')" class="validation-error">
                  {{ "DATACOLLECTIONINTERVAL_ERROR" | translate }}
                </div>
              </div>
            </div>
            <!-- Client Address -->
            <div class="form-item">
              <label class="form-label" for="clientAddress">{{ "DEVICESETUP_CLIENTADDRESS" | translate }}:</label>
              <div class="form-input">
                <input id="clientAddress" formControlName="clientAddress" type="number" />
                <div class="validation-instruction">{{ "DEVICESETUP_CLIENTADDRESSINFODESC" | translate }}</div>
              </div>
            </div>
          </div>
        </div>

        <!-- ===== SECTION: INSTALLATION & TIMING ===== -->
        <div class="form-section">
          <div class="section-header">
            <h5 class="section-name">{{ "DEVICESETUPTABS_INSTALLATIONTIMING" | translate }}</h5>
          </div>
          <div formGroupName="installationTiming" class="row g-0 m-0 d-flex justify-content-center">
            <!-- Service Latitude -->
            <div class="form-item">
              <label class="form-label" for="serviceLatitude">{{ "DEVICESETUP_SERVICELATITUDE" | translate }}:</label>
              <div class="form-input">
                <input id="serviceLatitude" formControlName="serviceLatitude" step="0.000001" type="number" />
                <div *ngIf="deviceForm.get('installationTiming.serviceLatitude')?.untouched"
                  class="validation-instruction">
                  {{ "DEVICESETUP_SERVICELATITUDEDESC" | translate }}
                </div>
                <div *ngIf="formErrorsExists('installationTiming.serviceLatitude')" class="validation-error">
                  {{ "DEVICESETUP_SERVICELATITUDEERROR" | translate }}
                </div>
              </div>
            </div>
            <!-- Service Longitude -->
            <div class="form-item">
              <label class="form-label" for="serviceLongitude">{{ "DEVICESETUP_SERVICELONGITUDE" | translate }}:</label>
              <div class="form-input">
                <input id="serviceLongitude" formControlName="serviceLongitude" step="0.000001" type="number" />
                <div *ngIf="deviceForm.get('installationTiming.serviceLongitude')?.untouched"
                  class="validation-instruction">
                  {{ "DEVICESETUP_SERVICELONGITUDEDESC" | translate }}
                </div>
                <div *ngIf="formErrorsExists('installationTiming.serviceLongitude')" class="validation-error">
                  {{ "DEVICESETUP_SERVICELONGITUDEERROR" | translate }}
                </div>
              </div>
            </div>
            <!-- Meter Installation Date -->
            <div class="form-item">
              <label class="form-label" for="meterInstallationDate">{{ "DEVICESETUP_INSTALLATIONDATE" | translate
                }}*</label>
              <div class="form-input">
                <div class="date-container" (click)="toggleDatepicker(); $event.stopPropagation()">
                  <span class="ps-2 pe-2">{{ "DATE" | translate }}</span>
                  <div class="date-input">
                    <input id="meterInstallationDate" [value]="selectedDate" formControlName="meterInstallationDate"
                      type="text" readonly />
                    <img alt="Calendar" src="assets/device/calendar.svg" />
                  </div>
                </div>
                <ng-container *ngIf="isDatepickerShown">
                  <app-datepicker #d [scale]="1.1" [range]="false"
                    [inputFromDate]="deviceForm.get('installationTiming.meterInstallationDate')?.value"
                    (dateRangeChanged)="onDateRangeChanged($event)"
                    (close)="isDatepickerShown = false"></app-datepicker>
                </ng-container>
                <div *ngIf="formErrorsExists('installationTiming.meterInstallationDate')" class="validation-error">
                  {{ "DEVICESETUP_INSTALLATIONDATE" | translate }} {{ "DEVICESETUP_ISREQUIRED" | translate }}.
                </div>
                <div
                  *ngIf="deviceForm.get('installationTiming.meterInstallationDate')?.untouched && deviceForm.get('installationTiming.meterInstallationDate')?.invalid"
                  class="validation-instruction">
                  {{ "DEVICESETUP_INSTALLATIONDATEDESC" | translate }}
                </div>
              </div>
            </div>
            <!-- Clock Offset -->
            <div class="form-item">
              <label class="form-label" for="clockOffset">{{ "CLOCK_OFFSET" | translate }}:</label>
              <div class="form-input">
                <input id="clockOffset" formControlName="clockOffset" type="number"
                  (keydown)="preventInvalidInput($event)" />
                <div *ngIf="!deviceForm.get('installationTiming.clockOffset')?.value" class="validation-instruction">
                  {{ "DEVICESETUP_CLOCKOFFSET" | translate }}
                </div>
                <div
                  *ngIf="deviceForm.get('installationTiming.clockOffset')?.touched && deviceForm.get('installationTiming.clockOffset')?.invalid"
                  class="validation-error">
                  {{ "DEVICESETUP_CLOCKOFFSETERROR" | translate }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- ===== SECTION: AUTHENTICATION ===== -->
        <div class="form-section">
          <div class="section-header">
            <h5 class="section-name">{{ "DEVICESETUPTABS_AUTHENTICATION" | translate }}</h5>
          </div>
          <div formGroupName="authentication" class="row g-0 m-0 d-flex justify-content-center">
            <!-- Authentication Type -->
            <div class="form-item">
              <label class="form-label" for="autentificationType">{{ "DEVICESETUP_AUTHTYPE" | translate }}:</label>
              <div class="form-input">
                <input id="autentificationType" formControlName="autentificationType" type="text" />
                <div class="validation-instruction">{{ "DEVICESETUP_AUTHTYPEINFODESC" | translate }}</div>
              </div>
            </div>
            <!-- Block Cipher Key -->
            <div class="form-item">
              <label class="form-label" for="blockCipherKey">{{ "DEVICESETUP_BLOCKCIPHERKEY" | translate }}:</label>
              <div class="form-input">
                <input id="blockCipherKey" formControlName="blockCipherKey" type="text" />
                <div *ngIf="!deviceForm.get('authentication.blockCipherKey')?.value" class="validation-instruction">
                  {{ "DEVICESETUP_BLOCKCIPHERKEYDESC" | translate }}
                </div>
              </div>
            </div>
            <!-- Authentication Key -->
            <div class="form-item">
              <label class="form-label" for="authenticationKey">{{ "DEVICESETUP_AUTHENTICATIONKEY" | translate
                }}:</label>
              <div class="form-input">
                <input id="authenticationKey" formControlName="authenticationKey" type="text" />
                <div *ngIf="!deviceForm.get('authentication.authenticationKey')?.value" class="validation-instruction">
                  {{ "DEVICESETUP_AUTHENTICATIONKEYDESC" | translate }}
                </div>
              </div>
            </div>
            <!-- Meter Security -->
            <div class="form-item">
              <label class="form-label" for="meterSecurity">{{ "DEVICESETUP_SECURITY" | translate }}*</label>
              <div class="form-input">
                <input id="meterSecurity" formControlName="meterSecurity" type="text" />
                <div class="validation-instruction">{{ "DEVICESETUP_SECURITYINFODESC" | translate }}</div>
              </div>
            </div>
            <!-- Password -->
            <div class="form-item">
              <label class="form-label" for="password">{{ "DEVICESETUP_PASSWORD" | translate }}</label>
              <div class="form-input">
                <div class="password-container">
                  <input id="password" formControlName="password" [type]="showPassword ? 'text' : 'password'" />
                  <img alt="Password" class="password-icon"
                    [src]="showPassword ? '../../assets/device/password-show.svg' : '../../assets/device/password-hide.svg'"
                    (click)="togglePasswordVisibility()" />
                </div>
                <div *ngIf="formErrorsExists('authentication.password')" class="validation-error">
                  {{ "DEVICESETUP_PASSWORD" | translate }} {{ "DEVICESETUP_ISREQUIRED" | translate }}.
                </div>
                <div
                  *ngIf="deviceForm.get('authentication.password')?.untouched && deviceForm.get('authentication.password')?.invalid"
                  class="validation-instruction">
                  {{ "DEVICESETUP_PASSWORDDESC" | translate }}
                </div>
              </div>
            </div>

            <!-- Change password on meter section -->
            <div class="password-change-section" *ngIf="isLowAuthType">
              <div class="form-item">
                <label class="form-label">{{ "DEVICESETUP_CHANGEPASSWORDONMETER" | translate }}</label>
                <div class="form-input">
                  <div class="toggle-wrapper">
                    <input type="checkbox" [(ngModel)]="changePasswordOnMeter"
                           [ngModelOptions]="{standalone: true}"
                           [disabled]="!!deviceForm.get('authentication.password')?.disabled"
                           (change)="onChangePasswordCheckboxToggle()" />
                  </div>
                  <div class="section-desc">
                    {{ "DEVICESETUP_CHANGEPASSWORDONMETER_DESC" | translate }}
                  </div>
                </div>
              </div>

              <ng-container *ngIf="changePasswordOnMeter">
                <!-- New password -->
                <div class="form-item">
                  <label class="form-label" for="newPassword">{{ "DEVICESETUP_NEWPASSWORD" | translate }}</label>
                  <div class="form-input">
                    <div class="password-container">
                      <input id="newPassword" formControlName="newPassword" [type]="showPassword ? 'text' : 'password'"
                             maxlength="8" (keydown.space)="$event.preventDefault()" />
                      <img alt="Password" class="password-icon"
                        [src]="showPassword ? '../../assets/device/password-show.svg' : '../../assets/device/password-hide.svg'"
                        (click)="togglePasswordVisibility()" />
                    </div>
                    <div *ngIf="deviceForm.get('authentication.newPassword')?.errors?.['pattern']"
                      class="validation-error">
                      {{ "DEVICES_NEWPASSWORDERROR" | translate }}
                    </div>
                  </div>
                </div>

                <!-- Repeat new password -->
                <div class="form-item">
                  <label class="form-label" for="repeatNewPassword">{{ "DEVICESETUP_REPEATNEWPASSWORD" | translate }}</label>
                  <div class="form-input">
                    <div class="password-container">
                      <input id="repeatNewPassword" formControlName="repeatNewPassword"
                             [type]="showPassword ? 'text' : 'password'" />
                      <img alt="Password" class="password-icon"
                        [src]="showPassword ? '../../assets/device/password-show.svg' : '../../assets/device/password-hide.svg'"
                        (click)="togglePasswordVisibility()" />
                    </div>
                    <div *ngIf="newPasswordEntered"
                      [class.validation-instruction]="repeatPasswordState !== 'mismatch'"
                      [class.validation-error]="repeatPasswordState === 'mismatch'"
                      [style.color]="repeatPasswordState === 'match' ? 'green' : null">
                      {{ (repeatPasswordState === 'match'
                            ? 'DEVICES_PASSWORDSMATCH'
                            : repeatPasswordState === 'mismatch'
                              ? 'DEVICES_PASSWORDSNOMATCH'
                              : 'DEVICES_REPEATNEWPASSWORD') | translate }}
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>

        <!-- Submit -->
        <div class="submit-divider mb-4"></div>
        <div class="form-item-button">
          <button class="button-submit" type="submit" [disabled]="passwordsMismatch">{{ "FINISHSETUP" | translate }}</button>
        </div>

      </div>
    </form>
  </div>
  }
</div>